import { render, staticRenderFns } from "./StudioLessonMediaCard.vue?vue&type=template&id=3421e4b7&scoped=true&"
import script from "./StudioLessonMediaCard.vue?vue&type=script&lang=ts&"
export * from "./StudioLessonMediaCard.vue?vue&type=script&lang=ts&"
import style0 from "./StudioLessonMediaCard.vue?vue&type=style&index=0&id=3421e4b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3421e4b7",
  null
  
)

export default component.exports